import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.isSmsInvite"],
  isSmsInvite => isSmsInvite
);
